import { render, staticRenderFns } from "./Enroll.vue?vue&type=template&id=fac522b0&"
import script from "./Enroll.vue?vue&type=script&lang=js&"
export * from "./Enroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports